import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import BookingModal from '../../components/experiences/BookingModal/BookingModal';
import { setExperienceBookingModal, setExperiencesList, setExperienceSelected } from '../../actions/experiences';
import { getCallMeNowSlots, setCallMeNowResponse } from '../../actions/callMeNow';
import ExperiencesDataListV2 from '../../components/experiences/Data/ExperiencesV2';
import { DATE_FORMAT, getCurrentTimeInCurrentTimezoneFormatted, getCurrentTimezone } from '../../api/CallMeNow';
import { getVhtSegment } from '../../util/VhtUtil';
import { PartnerContext } from '../../../../partner';

class BookingLauncherOnboarding extends Component {
  componentDidMount() {
    if (!this.props.experiencesList) {
      this.props.setExperiencesList(ExperiencesDataListV2);
    }
    const experiencesList =
      (this.props.experiencesList && this.props.experiencesList.data) || ExperiencesDataListV2.data;

    const selectedExperience = experiencesList.find((experience) => experience.megaUseCase === 'customappointment');

    if (selectedExperience) {
      selectedExperience.vhtSegment = getVhtSegment(selectedExperience.megaUseCase, this.props.context.productCode);
      this.props.setExperienceSelected(selectedExperience);

      if (!!selectedExperience.vhtSegment) {
        const requestTimeInCurrentTimezone = getCurrentTimeInCurrentTimezoneFormatted(DATE_FORMAT);
        this.props.setCallMeNowResponse({
          state: 'pending',
          errorCode: 0,
          vhtSlots: [],
          currentTimezone: '',
          waitInMinutes: -1,
          earliestSlot: null,
        });
        this.props.getCallMeNowSlots(selectedExperience.vhtSegment, 'null', requestTimeInCurrentTimezone);
      }
    }
  }

  renderBooking = () => {
    return (
      <button
        onClick={this.showBookingModal.bind(this, 'callMeLater')}
        className="resultContainer__bookingContainer-bottonContaier-1"
      >
        Schedule call
      </button>
    );
  };

  renderCall = () => {
    return (
      <div>
        <button
          onClick={this.showBookingModal.bind(this, 'callMeNow')}
          className="resultContainer__bookingContainer-bottonContaier-1"
        >
          Call me now
        </button>
        <button
          onClick={this.showBookingModal.bind(this, 'callMeLater')}
          className="resultContainer__bookingContainer-bottonContaier-2"
        >
          Book for later
        </button>
      </div>
    );
  };

  showBookingModal = (bookingModal) => {
    this.props.setExperienceBookingModal(bookingModal);
  };

  hideBookingModal = () => {
    this.props.setExperienceBookingModal(false);
  };

  isCallMeNowAvailable = () => {
    return (
      this.props.callMeNowResponse &&
      this.props.callMeNowResponse.state === 'success' &&
      !!this.props.callMeNowResponse.vhtSlots.length &&
      this.props.callMeNowResponse.waitInMinutes <= this.props.maxCustomerWaitTime
    );
  };

  hideBookingModal = () => {
    this.props.setExperienceBookingModal(false);
  };

  render() {
    return (
      <div className="resultContainer__bookingContainer-bottonContaier">
        {this.isCallMeNowAvailable() ? this.renderCall() : this.renderBooking()}
        {!!this.props.experienceBookingModal && <BookingModal parentCloseHandler={this.hideBookingModal} />}
      </div>
    );
  }
}

const BookingLauncherOnboardingWrapper = (props) => (
  <PartnerContext.Consumer>
    {(context) => <BookingLauncherOnboarding context={context[0]} {...props} />}
  </PartnerContext.Consumer>
);

const mapStateToProps = (state /*, ownProps*/) => ({
  experiencesList:
    state.experiences.experiencesList && state.experiences.experiencesList.version === 2
      ? state.experiences.experiencesList.data
      : null,
  experienceSelected: state.experiences.experienceSelected,
  experienceBookingModal: state.experiences.experienceBookingModal,
  callMeNowResponse: state.callMeNow.callMeNowResponse,
  maxCustomerWaitTime: state.callMeNow.maxCustomerWaitTime,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setExperiencesList,
      setExperienceBookingModal,
      setExperienceSelected,
      getCallMeNowSlots,
      setCallMeNowResponse,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BookingLauncherOnboardingWrapper));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/onboarding/BookingLancherOnboarding.js